require('./reimburseInvestment.scss');
const PropTypes = require('prop-types');
// @ vendor
const React = require('react');
// @ commons
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
// @ components
const ReimburseInvestmentStep1 = require('components/hireInvestmentFunds/reimburseInvestmentStep1/reimburseInvestmentStep1');
const { ReimburseInvestmentStep2 } = require('components/hireInvestmentFunds/reimburseInvestmentStep2/reimburseInvestmentStep2');
const ReimburseInvestmentSuccess = require('components/hireInvestmentFunds/reimburseInvestmentSuccess/reimburseInvestmentSuccess');
// @ helpers
const { formatText } = require('core/i18n').i18n;

class ReimburseInvestment extends React.Component {

    constructor(props) {
        super(props);
        this.onCancel = this.onCancel.bind(this);
        this.onFinish = this.onFinish.bind(this);
    }

    componentWillReceiveProps(newProps) {
        const { immReimburseInvestment, onFinish } = newProps;
        const finished = immReimburseInvestment.get('submitSuccessful');
        const visibleStepValid = immReimburseInvestment.getIn(['steps', 1, 'valid']);

        if (visibleStepValid && !finished) {
            onFinish();
        }
    }

    onCancel() {
        this.props.onCancel();
    }

    onFinish() {
        this.props.onFinish();
    }

    buildWizard() {
        const {
            immReimburseInvestment,
            validateStep,
            setVisibleStep,
            setWillCancel,
            disableButton,
            getReimburseExAntDetails,
            fundId,
            contractNumber,
            immInvestmentFund,
            balance,
            immFlagBasedFeatures
        } = this.props;

        const headerMenuData = {
            title: formatText('brokerReimburseInvestmentStep1-header'),
            linksData: []
        }
        const immSteps = immReimburseInvestment.get('steps');
        const stepsAmount = immSteps.size;
        const visibleStep = immReimburseInvestment.get('visibleStep');
        const immFinalButton = 'broker-reimburseInvestmentSubmit';
        const actions = {
            validateStep,
            setVisibleStep,
            setWillCancel,
            finish: this.onFinish,
            cancel: this.onCancel
        };

        return (
            <Wizard
                actions={actions}
                stepsAmount={stepsAmount}
                visibleStep={visibleStep}
                immSteps={immSteps}
                hasHeaderMenu={true}
                headerMenuData={headerMenuData}
            >
                <WizardStep
                    position="first"
                    cancelButton={true}
                    nextButtonDisabled={disableButton}
                >
                    <ReimburseInvestmentStep1
                        onSetAmount={this.props.handleSetAmount}
                        onSetParticipation={this.props.handleSetParticipation}
                        onChangeType={this.props.handleChangeType}
                        immMyInvestments={this.props.immMyInvestments}
                        immReimburseInvestment={this.props.immReimburseInvestment}
                        immInvestmentFund={immInvestmentFund}
                        balance={balance}
                        immFlagBasedFeatures={immFlagBasedFeatures}
                    />
                </WizardStep>
                <WizardStep
                    position="last"
                    cancelButton={true}
                    previousButton={true}
                    addLoadingBehaviour={true}
                    immFinalButton={immFinalButton}
                >
                    <ReimburseInvestmentStep2
                        immReimburseInvestment={this.props.immReimburseInvestment}
                        immBrokerFundLegalDocument={this.props.immBrokerFundLegalDocument}
                        getReimburseExAntDetails={getReimburseExAntDetails}
                        fundId={fundId}
                        contractNumber={contractNumber}
                        immFlagBasedFeatures={immFlagBasedFeatures}
                    />
                </WizardStep>
            </Wizard>
        );
    }

    render() {
        let content = (<ReimburseInvestmentSuccess
            immReimburseInvestment={this.props.immReimburseInvestment}
            immFlagBasedFeatures={this.props.immFlagBasedFeatures}
        />);

        if (this.props.immReimburseInvestment && !this.props.immReimburseInvestment.get('submitSuccessful')) {
            content = this.buildWizard();
        }

        return content;
    }
}

ReimburseInvestment.propTypes = {
    disableButton: PropTypes.bool.isRequired,
    immSteps: PropTypes.object,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    onFinish: PropTypes.func.isRequired,
    handleSetAmount: PropTypes.func.isRequired,
    handleChangeType: PropTypes.func.isRequired,
    immMyInvestments: PropTypes.object.isRequired,
    immReimburseInvestment: PropTypes.object.isRequired,
    getReimburseExAntDetails: PropTypes.func.isRequired,
    immBrokerFundLegalDocument: PropTypes.object.isRequired,
    fundId: PropTypes.string.isRequired,
    contractNumber: PropTypes.string.isRequired,
    handleSetParticipation: PropTypes.func.isRequired,
    immInvestmentFund: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
};

module.exports = ReimburseInvestment;
